import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconGraphs = props => (
  <SvgIcon {...props} viewBox="0 0 15.999999 15.999999">
    <path d="m6 16h4v-16h-4v16zm-6 0h4v-8h-4v8zm12-11v11h4v-11h-4z" />
  </SvgIcon>
);

export default IconGraphs;



// WEBPACK FOOTER //
// ./src/components/icons/IconGraphs.js